// extracted by mini-css-extract-plugin
export default {"slide":"TeamSwiper_slide__v6iWT"};